import React from 'react';

const LoginForm = ({ 
  userName, 
  setUserName, 
  userPassword, 
  setUserPassword,
  onLogin,
  onForgotPassword,
  onRegister,
  isSending,
  errorMessage,
  handleInputChange
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onLogin();
      e.preventDefault();
    }
  };

  return (
    <div className="login-container">
      <input
        className="login-input"
        type="text"
        placeholder="Enter email"
        value={userName}
        onChange={(e) => { setUserName(e.target.value); handleInputChange(); }}
        onKeyDown={handleKeyPress}
      />
      <input
        className="login-input"
        type="password"
        placeholder="Enter password"
        value={userPassword}
        onChange={(e) => { setUserPassword(e.target.value); handleInputChange(); }}
        onKeyDown={handleKeyPress}
      />
      <button className="start-button" onClick={onLogin} disabled={isSending}>
        {isSending ? <span className="loading-spinner"></span> : "Log In"}
      </button>

      <button
        className="forgot-password-link"
        onClick={onForgotPassword}
      >
        Forgot password?
      </button>

      <hr className="login-separator" />

      <button className="secondary-button" onClick={onRegister}>
        Create New Account
      </button>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  );
};

export default LoginForm;
